<script>
  import {
    onMount,
    getContext
  } from 'svelte';
  import Scan from './Scan.svelte';

  const {
    open
  } = getContext("simple-modal");
  const showScan = (i) => open(Scan, {
    "src": i
  }, {
    classWindowWrap: "scan-full-width",
    classContent: "scan-full-width-content",
    classWindow: "scan-window-full-width",
  });

  onMount(async () => {

  });
  let { item } = $props();
</script>
<div class="gallery-item">
  <span class="icon roll-scan-icon" aria-hidden="open rollscan" onclick={showScan(item.gallery.rollscan)}></span>
</div>